module.exports = __webpack_public_path__ + "static/media/cerrar_sesion.89e75a7e.svg";